import type { JSX } from 'react'
export function DotSeparator(): JSX.Element {
  return <span className="text-foreground-tertiary"> · </span>
}
